import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=64d19fc2&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=64d19fc2&prod&lang=scss&scoped=true"
import style1 from "./LanguageSwitcher.vue?vue&type=style&index=1&id=64d19fc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d19fc2",
  null
  
)

export default component.exports